import moment from "moment"

const DATES = [
  {
    occasion: 'Maharashtra Day',
    date: moment('20190501')
  },
  {
    occasion: 'Buddha Purnima',
    date: moment('20190512')
  },
  {
    occasion: 'Eid-Ul-Fitr',
    date: moment('20190604')
  },
  {
    occasion: 'Guru Purnima',
    date: moment('20190716')
  },
  {
    occasion: 'Bakri Eid',
    date: moment('20190811')
  },
  {
    occasion: 'Independence Day',
    date: moment('20190815')
  },
  {
    occasion: 'Janmashtami',
    date: moment('20190824')
  },
  {
    occasion: 'Ganesh Chaturthi',
    date: moment('20190902')
  },
  {
    occasion: 'Muharram',
    date: moment('20190928')
  },
  {
    occasion: 'Gandhi Jayanti',
    date: moment('20191002')
  },
  {
    occasion: 'Dussehra',
    date: moment('20191008')
  },
  {
    occasion: 'Valmiki Jayanti',
    date: moment('20191013')
  },
  {
    occasion: 'Diwali',
    date: moment('20191027')
  },
  {
    occasion: 'Eid-Ul-Milad',
    date: moment('20191109')
  },
  {
    occasion: 'Guru Nanak Gurupurab',
    date: moment('20191123')
  },
  {
    occasion: 'Christmas',
    date: moment('20191225')
  },
]

export default DATES;